import { render, staticRenderFns } from "./sendTemplateOnMail.vue?vue&type=template&id=26d5df0d&scoped=true"
import script from "./sendTemplateOnMail.vue?vue&type=script&lang=js"
export * from "./sendTemplateOnMail.vue?vue&type=script&lang=js"
import style1 from "./sendTemplateOnMail.vue?vue&type=style&index=1&id=26d5df0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d5df0d",
  null
  
)

export default component.exports